<template>
  <div class="wrapper">
    <h1>My Tasks</h1>
    <template>
      <!-- filters -->
      <!-- FIXME: Refactir filters into a separate component -->
      <div class="table-options">
        <span>Filters:</span>
        <div class="select-container select-container--no-label">
          <select @change="getTasks()" v-model="statusFilter">
            <option value="">All Statuses</option>
            <option v-for="status in statusList" v-bind:key="status.id" :value="status.id">{{ status.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <!-- <div class="select-container select-container--no-label">
          <select v-model="monthFilter">
            <option value="-1">All Months</option>
            <option v-for="month in monthList" v-bind:key="month.id" :value="month.id">{{ month.name }}</option>
          </select>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div> -->
      </div>
      <!-- tasks -->
      <div v-if="isLoading" class="loading"></div>
      <template v-if="tasks">
        <div v-if="tasks.length > 0" class="table">
          <div class="table__headers">
            <div></div>
            <div class="table__header">Status</div>
            <div class="table__header">Description</div>
            <div class="table__header">Type</div>
            <div class="table__header">Created date</div>
            <div class="table__header">Deadline</div>
            <div></div>
          </div>
          <template v-for="(task, index) in tasks">
            <router-link :key="task.id" :data-cy="`my-task-${index}`" class="table__row" :to="{ path: '/task/:id', name: 'taskId', params: { id: task.id } }">
              <div class="table__cell">
                <div
                  class="circle"
                  :class="[{ 'circle--active': task.status == 'approved' }, { 'circle--warning': task.status == 'pending-review' }, { 'circle--exported': task.status == 'exported' }]"
                ></div>
              </div>
              <div class="table__cell">{{ task.status }}</div>
              <div class="table__cell">{{ task.notesFreelancers }}</div>
              <div class="table__cell">{{ task.type }}</div>
              <div class="table__cell">
                {{ submitDateFormatted(task.submittedAt) }}
              </div>
              <div class="table__header">-</div>
              <!-- prettier-ignore -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
            </router-link>
          </template>
        </div>
      </template>
      <div v-else-if="statusFilter">
        <span>You do not have any tasks with selected status</span>
      </div>
      <div v-else>
        <span>You have not claimed any tasks yet</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'myTasks',
  data() {
    return {
      isLoading: true,
      statusFilter: '',
      // monthFilter: -1,
    }
  },
  methods: {
    getTasks() {
      var params = {
        endpoint: 'getbyfilters',
        claimedby: this.user.data.uid,
      }
      if (this.statusFilter) {
        params['status'] = this.statusFilter
      }
      this.$store
        .dispatch('fetchTasks', {
          params,
          userId: this.user.data.uid,
        })
        .then((this.isLoading = false))
    },
    submitDateFormatted(submitDate) {
      let date = new Date(submitDate)
      return date.toLocaleString('da-DK')
    },
  },
  mounted: function() {
    if (this.user.data.firestore.isAdmin) {
      this.$router.push('/overview/review')
    }
    this.getTasks()
  },

  computed: {
    ...mapGetters(['tasks', 'user', 'monthList', 'statusList']),
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/shared-styles/table.scss';
@import '@/assets/shared-styles/select.scss';
@import '@/assets/shared-styles/button.scss';
@import '@/assets/shared-styles/loader.scss';

.wrapper {
  display: grid;
  gap: 1.5rem;
  align-items: start;
  padding: 2rem 2rem;
}
.table__headers,
.table__row {
  grid-template-columns:
    50px 160px minmax(500px, auto) minmax(120px, auto) minmax(180px, auto)
    1fr auto;
}
.table__row > svg {
  transform: rotate(-90deg);
}
</style>
